// Modules
import { Action, createReducer, on } from '@ngrx/store';

// Interfaces
import {
  IAccidentDetailTransportation,
  IFile,
} from '@accidents/shared/interfaces/accident-transportation';

// Actions
import * as DetailAccidentActions from '@accidents/store/actions/detail-accident-transportation.actions';

export interface AccidentDetailTransportationState {
  accident: IAccidentDetailTransportation;
  loading: boolean;
  files: IFile[];
}

export const initialAccidentDetailTransportationState: AccidentDetailTransportationState =
  {
    accident: undefined,
    loading: false,
    files: [],
  };

const AccidentDetailTransportationReducer = createReducer(
  initialAccidentDetailTransportationState,
  on(
    DetailAccidentActions.reset,
    () => initialAccidentDetailTransportationState
  ),
  on(DetailAccidentActions.getAccidentDetailRequested, state => ({
    ...state,
    loading: true,
  })),
  on(DetailAccidentActions.getAccidentDetailSuccess, (state, action) => ({
    ...state,
    accident: action.payload,
    loading: false,
  })),
  on(DetailAccidentActions.addAccidentFilesRequested, state => ({
    ...state,
    loading: true,
  })),
  on(DetailAccidentActions.addAccidentFilesResponse, (state, action) => ({
    ...state,
    loading: false,
    files: action.payload,
  })),
  on(DetailAccidentActions.deleteAccidentFileRequested, state => ({
    ...state,
    loading: true,
  })),
  on(DetailAccidentActions.deleteAccidentFileResponse, state => ({
    ...state,
    loading: false,
  })),
  on(DetailAccidentActions.updateAccidentFileRequested, state => ({
    ...state,
    loading: true,
  })),
  on(DetailAccidentActions.updateAccidentFileResponse, state => ({
    ...state,
    loading: false,
  })),
  on(DetailAccidentActions.clearAccidentDetail, state => ({
    ...state,
    accident: undefined,
  })),
  on(DetailAccidentActions.getAccidentDetailFailure, state => ({
    ...state,
    loading: false,
  })),

  on(DetailAccidentActions.downloadAccidentFilesZipRequest, state => ({
    ...state,
    loading: true,
  })),
  on(DetailAccidentActions.downloadAccidentFilesZipResponse, state => ({
    ...state,
    loading: false,
  }))
);

export function reducer(
  state: AccidentDetailTransportationState | undefined,
  action: Action
): AccidentDetailTransportationState {
  return AccidentDetailTransportationReducer(state, action);
}
